module.exports = __webpack_public_path__ + "img/b9c62ec4b9e553395d410f0840d57758.png";